import { createFileRoute } from '@tanstack/react-router'
import { AppHeader } from '@/shared/components/layout/AppHeader'
import { LeagueCreationForm } from '@/features/league/components/LeagueCreationForm'
import { withLegacySkin } from '@/shared/components/layout/LegacySkin'

export const Route = createFileRoute('/_authenticated/league/new')({
  component: withLegacySkin(LeagueNewPage),
})

function LeagueNewPage() {
  return (
    <>
      <AppHeader title="Nova Liga" />
      <LeagueCreationForm />
    </>
  )
}
